export const configuration = {
  urls: {
    PRODUCT_HIERARCHY_URL: 'https://product-hierarchy.prod.merch.vpsvc.com/',
    MSX_URL: 'https://merchandising-site-experience.prod.merch.vpsvc.com/',
    DPS_URL: 'https://discovery-pages-service.productdiscovery.vpsvc.com/',
    ATTRIBUTE_MAPPINGS_URL: 'https://attribute-mappings.productdiscovery.vpsvc.com/',
    MTS_URL: 'https://merchandising-tagger.prod.p3.vpsvc.com/',
    MERCHANDISING_CONTENT_SERVICE_CDN_URL: 'https://mcs-cdn.prod.content-platform.vpsvc.com',
    URL_SERVICE_URL: 'https://url.prod.merch.vpsvc.com/',
    TENANT_REGISTRY_URL: 'https://api.experience.cimpress.io/tenants/v1/',
  },
  requestor: 'plp-scope-definition',
};
